export const DEVLOPMENT_ENV = 'development';
export const TEST_ENV = 'test';
export const PRODUCTION_ENV = 'prod';
export const LOCAL_ENV = 'local';
